import axios, { InternalAxiosRequestConfig } from 'axios';
import { User } from 'oidc-client-ts';

const BASE_URL = import.meta.env.VITE_API_URL;

export const getUser = () => {
  const oidcStorage = localStorage.getItem(
    `oidc.user:${import.meta.env.VITE_AUTHORITY}:${import.meta.env.VITE_CLIENT_ID}`
  );
  if (!oidcStorage) {
    return null;
  }
  return User.fromStorageString(oidcStorage);
};

// Create an instance of Axios
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor to add the token to headers
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const user = getUser();

    if (user?.access_token) {
      config.headers.Authorization = `Bearer ${user?.access_token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
